import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface SnbCoTermStoreState {
}
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    getCotermData(context : ActionContext<SnbCoTermStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `coterm/get-coterm-data?requsername=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    postforCoTermDate(context : ActionContext<SnbCoTermStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `coterm/update-coterm-data?requsername=${payload.userName}`;
      return ApiServiceWrapper.post(endpoint, payload.request);
    },
    completeCoTerm(context : ActionContext<SnbCoTermStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `coterm/complete-coterm?requsername=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    bulkCotermActivation(context : ActionContext<SnbCoTermStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/bulkcotermactivation';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
  },
  namespaced: true,
} as Module<SnbCoTermStoreState, RootStoreState>;
